import strings from 'utils/strings'
import { Panel } from '../Dash/Panels/Panels.style'
import {
  DASH_LABELS,
  DASH_TYPES,
  DIGITAL_ICU_LEFT_FILE_NAME,
} from './dashConstants'

export const META_BY_LOCATION_DETAIL = {
  F: {
    dependency: {
      panelNumber: 'A66-01975-000',
      top: 9,
      left: 10,
      width: 69,
      height: 117,
      zIndex: 5,
    },
  },
  Y: {
    dependency: {
      panelNumber: 'A66-01975-000',
      top: 9,
      left: 10,
      width: 69,
      height: 117,
      zIndex: 5,
    },
  },
  SSMSF: {
    partOverride: 'A06-90732-000',
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
  HH: {
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
    hidePendingPill: true,
  },
  C: {
    partOverride: 'CAS216806',
  },
  MST: {
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
  MSF: {
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
  LSMST: {
    partOverride: 'A06-90731-000',
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
  ICU: {
    label: DASH_LABELS.A_PANEL_ICU,
    partOverride: '43N_ICU_RHD',
    noTooltip: true,
    disableEvents: true,
    partExpected: true,
    noShowPartNumber: true,
  },
  ICUC5: {
    label: DASH_LABELS.A_PANEL_ICU,
    partOverride: DIGITAL_ICU_LEFT_FILE_NAME,
    noTooltip: true,
    disableEvents: true,
    partExpected: true,
    noShowPartNumber: true,
  },
  // PBI 479416: use the digital display graphic for RHD AUDSP, as on 38N LHD.
  AUDSP: {
    partOverride: '000 446',
    label: DASH_LABELS.RIGHT_HAND_B_PANEL_AUX,
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
  },
  AGFAC: {
    label: DASH_LABELS.RIGHT_HAND_B_PANEL_AG,
    partOverride: 'A22_73784_RHD',
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
  },
  AUPNL: {
    partOverride: 'A22-74137-001',
    label: DASH_LABELS.RIGHT_HAND_B_PANEL_AUX,
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
    containedIn: 'AGFAC',
  },
}

export const DASH_META = {
  name: DASH_TYPES.DASH_38N_003_002,
  panels: ['AGFAC', 'ICU'],
  navPanels: ['AUPNL'],
  navOrder: ['AGFAC', 'AUPNL', 'ICU'],
  // PBI 479416: fit WP4425's digital ICU beside the full-width AGFAC.
  width: 4400,
  height: 1336,
  panelsStyle: `
    & ${Panel}:nth-child(2){
      margin-left: 320px;
    }
  `,
}

export const FALLBACK_COMPONENTS_BY_DETAIL = {
  SS: 'Switch',
  A: 'Gauge',
  AC: 'Radio_CP001',
}

export default {
  ...DASH_META,
  ...META_BY_LOCATION_DETAIL,
  fallbacks: FALLBACK_COMPONENTS_BY_DETAIL,
  lists: {
    ICU: {
      id: 'ICU',
      label: 'A Panel: ICU',
      groups: {},
    },
    AUPNL: {
      id: 'AUPNL',
      label: 'B Panel: Right Hand Aux',
      groups: {
        AU800: {
          order: 0,
          id: 'AU800',
          panel: 'AUPNL',
          label: 'MSF 8',
          canDragGroup: true,
          isMsfOrMst: true,
          detail: ['SS'],
        },
        AU700: {
          order: 1,
          id: 'AU700',
          panel: 'AUPNL',
          label: 'MSF 7',
          canDragGroup: true,
          isMsfOrMst: true,
          detail: ['SS'],
        },
        AU600: {
          order: 2,
          id: 'AU600',
          panel: 'AUPNL',
          label: 'MSF 6',
          canDragGroup: true,
          isMsfOrMst: true,
          detail: ['SS'],
        },
        AU500: {
          order: 3,
          id: 'AU500',
          panel: 'AUPNL',
          label: 'MSF 5',
          canDragGroup: true,
          isMsfOrMst: true,
          detail: ['SS'],
        },
        AU400: {
          order: 4,
          id: 'AU400',
          panel: 'AUPNL',
          label: 'MSF 4',
          canDragGroup: true,
          isMsfOrMst: true,
          detail: ['SS'],
        },
        AU300: {
          order: 5,
          id: 'AU300',
          panel: 'AUPNL',
          label: 'MSF 3',
          canDragGroup: true,
          isMsfOrMst: true,
          detail: ['SS'],
        },
        au_gauges: {
          id: 'au_gauges',
          panel: 'AUPNL',
          label: 'Aux Gauges',
          detail: ['A'],
        },
        au_other: {
          id: 'au_other',
          panel: 'AUPNL',
          label: 'Aux Other',
          // AU250: accept corrected A-A and existing AA layout data (PBI pending).
          detail: [
            'B',
            'D',
            'H',
            'J',
            'G',
            'S',
            'T',
            'U',
            'L',
            'AA',
            'A-A',
            'BB',
          ],
        },
      },
    },
    AGFAC: {
      id: 'AGFAC',
      label: 'B Panel: Right Hand',
      groups: {
        LSMST: {
          order: 2,
          id: 'LSMST',
          panel: 'AGFAC',
          label: 'Right MSF',
          isMsfOrMst: true,
          detail: ['SS'],
          staticPart: {
            label: strings.hazard_lights,
            afterIndex: 4,
          },
        },
        CSMAN: {
          order: 1,
          id: 'CSMAN',
          isMsfOrMst: true,
          panel: 'AGFAC',
          label: 'Center MSF',
          detail: ['SS'],
        },
        RSMAN: {
          order: 0,
          id: 'RSMAN',
          isMsfOrMst: true,
          panel: 'AGFAC',
          label: 'Left MSF',
          detail: ['SS'],
        },
        switches: {
          order: 3,
          id: 'switches',
          panel: 'AGFAC',
          label: 'Lower Switches',
          detail: ['F'],
        },
        gauges: {
          order: 4,
          id: 'gauges',
          panel: 'AGFAC',
          label: 'Gauges',
          detail: ['A'],
        },
        other: {
          order: 5,
          id: 'other',
          panel: 'AGFAC',
          label: 'Other',
          detail: ['C', 'B', 'E', 'DD', 'V', 'X', 'Y', 'S', 'L', 'EE'],
        },
      },
    },
  },
}
